(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.BbobPresetVue = {}));
}(this, (function (exports) { 'use strict';

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var es = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;
  exports.createPreset = createPreset;
  exports.default = void 0;
  /* eslint-disable indent */

  var isTagNode = function isTagNode(el) {
    return typeof el === 'object' && !!el.tag;
  };

  function process(tags, tree, core, options) {
    tree.walk(function (node) {
      return isTagNode(node) && tags[node.tag] ? tags[node.tag](node, core, options) : node;
    });
  }
  /**
   * Creates preset for @bbob/core
   * @param defTags {Object}
   * @param processor {Function} a processor function of tree
   * @returns {function(*=): function(*=, *=): void}
   */


  function createPreset(defTags, processor) {
    if (processor === void 0) {
      processor = process;
    }

    var presetFactory = function presetFactory(opts) {
      if (opts === void 0) {
        opts = {};
      }

      presetFactory.options = Object.assign(presetFactory.options || {}, opts);

      var presetExecutor = function presetExecutor(tree, core) {
        return processor(defTags, tree, core, presetFactory.options);
      };

      presetExecutor.options = presetFactory.options;
      return presetExecutor;
    };

    presetFactory.extend = function (callback) {
      return createPreset(callback(defTags, presetFactory.options), processor);
    };

    return presetFactory;
  }

  var _default = createPreset;
  exports.default = _default;
  });

  unwrapExports(es);
  var es_1 = es.createPreset;

  var char_1 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;
  exports.BACKSLASH = exports.PLACEHOLDER_SPACE = exports.PLACEHOLDER_SPACE_TAB = exports.SLASH = exports.CLOSE_BRAKET = exports.OPEN_BRAKET = exports.SPACE = exports.QUOTEMARK = exports.EQ = exports.TAB = exports.R = exports.F = exports.N = void 0;
  var N = '\n';
  exports.N = N;
  var TAB = '\t';
  exports.TAB = TAB;
  var F = '\f';
  exports.F = F;
  var R = '\r';
  exports.R = R;
  var EQ = '=';
  exports.EQ = EQ;
  var QUOTEMARK = '"';
  exports.QUOTEMARK = QUOTEMARK;
  var SPACE = ' ';
  exports.SPACE = SPACE;
  var OPEN_BRAKET = '[';
  exports.OPEN_BRAKET = OPEN_BRAKET;
  var CLOSE_BRAKET = ']';
  exports.CLOSE_BRAKET = CLOSE_BRAKET;
  var SLASH = '/';
  exports.SLASH = SLASH;
  var BACKSLASH = '\\';
  exports.BACKSLASH = BACKSLASH;
  var PLACEHOLDER_SPACE_TAB = '    ';
  exports.PLACEHOLDER_SPACE_TAB = PLACEHOLDER_SPACE_TAB;
  var PLACEHOLDER_SPACE = ' '; // const getChar = String.fromCharCode;

  exports.PLACEHOLDER_SPACE = PLACEHOLDER_SPACE;
  });

  unwrapExports(char_1);
  var char_2 = char_1.BACKSLASH;
  var char_3 = char_1.PLACEHOLDER_SPACE;
  var char_4 = char_1.PLACEHOLDER_SPACE_TAB;
  var char_5 = char_1.SLASH;
  var char_6 = char_1.CLOSE_BRAKET;
  var char_7 = char_1.OPEN_BRAKET;
  var char_8 = char_1.SPACE;
  var char_9 = char_1.QUOTEMARK;
  var char_10 = char_1.EQ;
  var char_11 = char_1.TAB;
  var char_12 = char_1.R;
  var char_13 = char_1.F;
  var char_14 = char_1.N;

  var lib = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;
  exports.isEOL = exports.isStringNode = exports.isTagNode = exports.getUniqAttr = exports.getNodeLength = exports.escapeHTML = exports.appendToNode = exports.attrValue = exports.attrsToString = void 0;



  var isTagNode = function isTagNode(el) {
    return typeof el === 'object' && !!el.tag;
  };

  exports.isTagNode = isTagNode;

  var isStringNode = function isStringNode(el) {
    return typeof el === 'string';
  };

  exports.isStringNode = isStringNode;

  var isEOL = function isEOL(el) {
    return el === char_1.N;
  };

  exports.isEOL = isEOL;

  var keysReduce = function keysReduce(obj, reduce, def) {
    return Object.keys(obj).reduce(reduce, def);
  };

  var getNodeLength = function getNodeLength(node) {
    if (isTagNode(node)) {
      return node.content.reduce(function (count, contentNode) {
        return count + getNodeLength(contentNode);
      }, 0);
    }

    if (isStringNode(node)) {
      return node.length;
    }

    return 0;
  };
  /**
   * Appends value to Tag Node
   * @param {TagNode} node
   * @param value
   */


  exports.getNodeLength = getNodeLength;

  var appendToNode = function appendToNode(node, value) {
    node.content.push(value);
  };
  /**
   * Replaces " to &qquot;
   * @param {String} value
   */


  exports.appendToNode = appendToNode;

  var escapeHTML = function escapeHTML(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;') // eslint-disable-next-line no-script-url
    .replace(/(javascript):/gi, '$1%3A');
  };
  /**
   * Acept name and value and return valid html5 attribute string
   * @param {String} name
   * @param {String} value
   * @return {string}
   */


  exports.escapeHTML = escapeHTML;

  var attrValue = function attrValue(name, value) {
    var type = typeof value;
    var types = {
      "boolean": function boolean() {
        return value ? "" + name : '';
      },
      number: function number() {
        return name + "=\"" + value + "\"";
      },
      string: function string() {
        return name + "=\"" + escapeHTML(value) + "\"";
      },
      object: function object() {
        return name + "=\"" + escapeHTML(JSON.stringify(value)) + "\"";
      }
    };
    return types[type] ? types[type]() : '';
  };
  /**
   * Transforms attrs to html params string
   * @param values
   */


  exports.attrValue = attrValue;

  var attrsToString = function attrsToString(values) {
    // To avoid some malformed attributes
    if (values == null) {
      return '';
    }

    return keysReduce(values, function (arr, key) {
      return [].concat(arr, [attrValue(key, values[key])]);
    }, ['']).join(' ');
  };
  /**
   * Gets value from
   * @example
   * getUniqAttr({ 'foo': true, 'bar': bar' }) => 'bar'
   * @param attrs
   * @returns {string}
   */


  exports.attrsToString = attrsToString;

  var getUniqAttr = function getUniqAttr(attrs) {
    return keysReduce(attrs, function (res, key) {
      return attrs[key] === key ? attrs[key] : null;
    }, null);
  };

  exports.getUniqAttr = getUniqAttr;
  });

  unwrapExports(lib);
  var lib_1 = lib.isEOL;
  var lib_2 = lib.isStringNode;
  var lib_3 = lib.isTagNode;
  var lib_4 = lib.getUniqAttr;
  var lib_5 = lib.getNodeLength;
  var lib_6 = lib.escapeHTML;
  var lib_7 = lib.appendToNode;
  var lib_8 = lib.attrValue;
  var lib_9 = lib.attrsToString;

  var TagNode_1 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;
  exports["default"] = exports.TagNode = void 0;





  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var getTagAttrs = function getTagAttrs(tag, params) {
    var uniqAattr = (0, lib.getUniqAttr)(params);

    if (uniqAattr) {
      var tagAttr = (0, lib.attrValue)(tag, uniqAattr);

      var attrs = _extends({}, params);

      delete attrs[uniqAattr];
      var attrsStr = (0, lib.attrsToString)(attrs);
      return "" + tagAttr + attrsStr;
    }

    return "" + tag + (0, lib.attrsToString)(params);
  };

  var TagNode =
  /*#__PURE__*/
  function () {
    function TagNode(tag, attrs, content) {
      this.tag = tag;
      this.attrs = attrs;
      this.content = Array.isArray(content) ? content : [content];
    }

    var _proto = TagNode.prototype;

    _proto.attr = function attr(name, value) {
      if (typeof value !== 'undefined') {
        this.attrs[name] = value;
      }

      return this.attrs[name];
    };

    _proto.append = function append(value) {
      return (0, lib.appendToNode)(this, value);
    };

    _proto.toTagStart = function toTagStart(_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          _ref$openTag = _ref.openTag,
          openTag = _ref$openTag === void 0 ? char_1.OPEN_BRAKET : _ref$openTag,
          _ref$closeTag = _ref.closeTag,
          closeTag = _ref$closeTag === void 0 ? char_1.CLOSE_BRAKET : _ref$closeTag;

      var tagAttrs = getTagAttrs(this.tag, this.attrs);
      return "" + openTag + tagAttrs + closeTag;
    };

    _proto.toTagEnd = function toTagEnd(_temp2) {
      var _ref2 = _temp2 === void 0 ? {} : _temp2,
          _ref2$openTag = _ref2.openTag,
          openTag = _ref2$openTag === void 0 ? char_1.OPEN_BRAKET : _ref2$openTag,
          _ref2$closeTag = _ref2.closeTag,
          closeTag = _ref2$closeTag === void 0 ? char_1.CLOSE_BRAKET : _ref2$closeTag;

      return "" + openTag + char_1.SLASH + this.tag + closeTag;
    };

    _proto.toTagNode = function toTagNode() {
      return new TagNode(this.tag.toLowerCase(), this.attrs, this.content);
    };

    _proto.toString = function toString(_temp3) {
      var _ref3 = _temp3 === void 0 ? {} : _temp3,
          _ref3$openTag = _ref3.openTag,
          openTag = _ref3$openTag === void 0 ? char_1.OPEN_BRAKET : _ref3$openTag,
          _ref3$closeTag = _ref3.closeTag,
          closeTag = _ref3$closeTag === void 0 ? char_1.CLOSE_BRAKET : _ref3$closeTag;

      var isEmpty = this.content.length === 0;
      var content = this.content.reduce(function (r, node) {
        return r + node.toString({
          openTag: openTag,
          closeTag: closeTag
        });
      }, '');
      var tagStart = this.toTagStart({
        openTag: openTag,
        closeTag: closeTag
      });

      if (isEmpty) {
        return tagStart;
      }

      return "" + tagStart + content + this.toTagEnd({
        openTag: openTag,
        closeTag: closeTag
      });
    };

    _createClass(TagNode, [{
      key: "length",
      get: function get() {
        return (0, lib.getNodeLength)(this);
      }
    }]);

    return TagNode;
  }();

  exports.TagNode = TagNode;

  TagNode.create = function (tag, attrs, content) {
    if (attrs === void 0) {
      attrs = {};
    }

    if (content === void 0) {
      content = [];
    }

    return new TagNode(tag, attrs, content);
  };

  TagNode.isOf = function (node, type) {
    return node.tag === type;
  };

  var _default = TagNode;
  exports["default"] = _default;
  });

  unwrapExports(TagNode_1);
  var TagNode_2 = TagNode_1.TagNode;

  var defaultTags = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;
  exports.default = void 0;



  var _TagNode = _interopRequireDefault(TagNode_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable no-plusplus,no-lonely-if */


  var isStartsWith = function isStartsWith(node, type) {
    return node[0] === type;
  };

  var styleMap = {
    color: function color(val) {
      return "color:" + val + ";";
    },
    size: function size(val) {
      return "font-size:" + val + ";";
    }
  };

  var getStyleFromAttrs = function getStyleFromAttrs(attrs) {
    return Object.keys(attrs).reduce(function (acc, key) {
      return styleMap[key] ? acc.concat(styleMap[key](attrs[key])) : acc;
    }, []).join(' ');
  };

  var asListItems = function asListItems(content) {
    var listIdx = 0;
    var listItems = [];

    var createItemNode = function createItemNode() {
      return _TagNode.default.create('li');
    };

    var ensureListItem = function ensureListItem(val) {
      listItems[listIdx] = listItems[listIdx] || val;
    };

    var addItem = function addItem(val) {
      if (listItems[listIdx] && listItems[listIdx].content) {
        listItems[listIdx].content = listItems[listIdx].content.concat(val);
      } else {
        listItems[listIdx] = listItems[listIdx].concat(val);
      }
    };

    content.forEach(function (el) {
      if ((0, lib.isStringNode)(el) && isStartsWith(el, '*')) {
        if (listItems[listIdx]) {
          listIdx++;
        }

        ensureListItem(createItemNode());
        addItem(el.substr(1));
      } else if ((0, lib.isTagNode)(el) && _TagNode.default.isOf(el, '*')) {
        if (listItems[listIdx]) {
          listIdx++;
        }

        ensureListItem(createItemNode());
      } else if (!(0, lib.isTagNode)(listItems[listIdx])) {
        listIdx++;
        ensureListItem(el);
      } else if (listItems[listIdx]) {
        addItem(el);
      } else {
        ensureListItem(el);
      }
    });
    return [].concat(listItems);
  };

  var renderUrl = function renderUrl(node, render) {
    return (0, lib.getUniqAttr)(node.attrs) ? (0, lib.getUniqAttr)(node.attrs) : render(node.content);
  };

  var toNode = function toNode(tag, attrs, content) {
    return {
      tag: tag,
      attrs: attrs,
      content: content
    };
  };

  var _default = {
    b: function b(node) {
      return toNode('span', {
        style: 'font-weight: bold;'
      }, node.content);
    },
    i: function i(node) {
      return toNode('span', {
        style: 'font-style: italic;'
      }, node.content);
    },
    u: function u(node) {
      return toNode('span', {
        style: 'text-decoration: underline;'
      }, node.content);
    },
    s: function s(node) {
      return toNode('span', {
        style: 'text-decoration: line-through;'
      }, node.content);
    },
    url: function url(node, _ref, options) {
      var render = _ref.render;
      return toNode('a', {
        href: renderUrl(node, render)
      }, node.content);
    },
    img: function img(node, _ref2) {
      var render = _ref2.render;
      return toNode('img', {
        src: render(node.content)
      }, null);
    },
    quote: function quote(node) {
      return toNode('blockquote', {}, [toNode('p', {}, node.content)]);
    },
    code: function code(node) {
      return toNode('pre', {}, node.content);
    },
    style: function style(node) {
      return toNode('span', {
        style: getStyleFromAttrs(node.attrs)
      }, node.content);
    },
    list: function list(node) {
      var type = (0, lib.getUniqAttr)(node.attrs);
      return toNode(type ? 'ol' : 'ul', type ? {
        type: type
      } : {}, asListItems(node.content));
    }
  };
  exports.default = _default;
  });

  unwrapExports(defaultTags);

  var es$1 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;
  exports.default = void 0;



  var _defaultTags = _interopRequireDefault(defaultTags);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /* eslint-disable indent */


  var _default = (0, es.createPreset)(_defaultTags.default);

  exports.default = _default;
  });

  var presetHTML5 = unwrapExports(es$1);

  var tagAttr = function tagAttr(style) {
    return {
      attrs: {
        style: style
      }
    };
  };
  var createTags = function createTags(tags) {
    return {
      b: function b() {
        return _extends({}, tags.b.apply(tags, arguments), {}, tagAttr({
          fontWeight: 'bold'
        }));
      },
      i: function i() {
        return _extends({}, tags.i.apply(tags, arguments), {}, tagAttr({
          fontStyle: 'italic'
        }));
      },
      u: function u() {
        return _extends({}, tags.u.apply(tags, arguments), {}, tagAttr({
          textDecoration: 'underline'
        }));
      },
      s: function s() {
        return _extends({}, tags.s.apply(tags, arguments), {}, tagAttr({
          textDecoration: 'line-through'
        }));
      }
    };
  };
  var index = presetHTML5.extend(function (tags) {
    return _extends({}, tags, {}, createTags(tags));
  });

  exports.createTags = createTags;
  exports.default = index;
  exports.tagAttr = tagAttr;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bbob/preset-vue/dist/index.js
// module id = g8n3
// module chunks = 6